import { Card, CardContent, Grid, Paper, Stack, Tooltip, Typography } from "@mui/material";
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";

type PluginCardProps = {
    available: boolean
}

const NetsoinsCapacity = {
    consultation: true, // true now with MED-920
    patients: true,
    doctors: true
}


function PluginCard(props: PluginCardProps) {
    const { available } = props
    const { t } = useTranslation()
    const generateIcon = (isChecked: boolean) => {
        return (
            <Box
                className={isChecked ? 'pulse-success' : ''}
                sx={[
                    {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '32px',
                        height: '32px',
                        background: isChecked ? '#38A169' : '#E5E7EB',
                        borderRadius: '16px',
                    },
                ]}
            >
                {isChecked ? <CheckRoundedIcon fontSize="small" htmlColor="#FFF" /> : <CloseRoundedIcon fontSize="small" htmlColor="#FFF" />}
            </Box>
        )
    }

    const availableComponent = () => {
        return (

            <>
                <Grid container direction="column">
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <Typography variant="body1">
                            {t('page.netsoins.plugin.consultation.label')}
                        </Typography>
                        <Tooltip title={t('page.netsoins.plugin.consultation.tooltip')}>

                            {generateIcon(NetsoinsCapacity.consultation)}
                        </Tooltip>

                        <Typography variant="body1">
                            {t('page.netsoins.plugin.patients.label')}
                        </Typography>
                        <Tooltip title={t('page.netsoins.plugin.patients.tooltip')}>
                            {generateIcon(NetsoinsCapacity.patients)}
                        </Tooltip>

                        <Typography variant="body1">
                            {t('page.netsoins.plugin.doctors.label')}
                        </Typography>
                        <Tooltip title={t('page.netsoins.plugin.doctors.tooltip')}>
                            {generateIcon(NetsoinsCapacity.doctors)}
                        </Tooltip>

                    </Stack>
                </Grid>
            </>
        )
    }

    const nonAvailableComponent = () => {
        return (
            <>
                <Typography variant="body1">
                    {t('page.netsoins.noConnector.description')}
                </Typography>
            </>
        )
    }

    return (
        <Paper>
            <Card>
                <CardContent>
                    {!!available ? (availableComponent()) : (nonAvailableComponent())}
                </CardContent>
            </Card>
        </Paper>
    )
}

export default PluginCard